import React, { useState, useEffect } from 'react';
import GRLPortal from './GRLPortal';
import './App.css';

function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [entity, setEntity] = useState('');
  const [token, setToken] = useState('');
  const [appenv, setAppenv] = useState('local');
  const [product, setProduct] = useState('MLT');
  const [currentRoute, setCurrentRoute] = useState(window.location.pathname);

  // Load saved values from localStorage on component mount
  useEffect(() => {
    const savedEntity = localStorage.getItem('grl-entity');
    const savedToken = localStorage.getItem('grl-token');
    const savedAppenv = localStorage.getItem('grl-appenv');
    const savedProduct = localStorage.getItem('grl-product');
    if (savedEntity) setEntity(savedEntity);
    if (savedToken) setToken(savedToken);
    if (savedAppenv) setAppenv(savedAppenv);
    if (savedProduct) setProduct(savedProduct);
    
    // Auto-open popup if entity, token, appenv, or product is missing
    if (!savedEntity || !savedToken || !savedAppenv || !savedProduct) {
      setShowPopup(true);
    }

    // Set initial route
    setCurrentRoute(window.location.pathname);

    // Listen for URL changes (for browser back/forward buttons)
    const handleRouteChange = () => {
      setCurrentRoute(window.location.pathname);
    };

    window.addEventListener('popstate', handleRouteChange);

    // Cleanup
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  const handleSave = () => {
    localStorage.setItem('grl-entity', entity);
    localStorage.setItem('grl-token', token);
    localStorage.setItem('grl-appenv', appenv);
    localStorage.setItem('grl-product', product);
    setShowPopup(false);
    // Refresh the page to pick up the latest values
    window.location.reload();
  };

  const handleCancel = () => {
    setShowPopup(false);
  };

  const handleReviewClick = () => {
    const currentPath = window.location.pathname;
    if (currentPath === '/review') {
      // If we're on /review, navigate to /customer-portal
      setCurrentRoute('/customer-portal');
      window.location.href = '/customer-portal';
    } else {
      // If we're on any other route (like /customer-portal), navigate to /review
      setCurrentRoute('/review');
      window.location.href = '/review';
    }
  };

  // Debug logging
  useEffect(() => {
    console.log('App - Current Entity:', entity);
    console.log('App - Current Token:', token ? 'Token set' : 'No token');
    console.log('App - Current AppEnv:', appenv);
    console.log('App - Current Product:', product);
  }, [entity, token, appenv, product]);

  return (
    <div className="App">
      <main className="App-main">
        <GRLPortal entity={entity} token={token} appenv={appenv} product={product} />
      </main>
      
      {/* Floating buttons */}
      <button 
        className="floating-button"
        onClick={() => setShowPopup(true)}
        title="Configure"
      >
        ⚙️
      </button>

      <button 
        className="floating-button review-button"
        onClick={handleReviewClick}
        title={currentRoute === '/review' ? 'Go to Customer Portal' : 'Go to Review'}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
        </svg>
      </button>

      {/* Popup overlay */}
      {showPopup && (
        <div className="popup-overlay" onClick={handleCancel}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h3>GRL Configuration</h3>
            <div className="form-group">
              <label htmlFor="appenv">App Environment:</label>
              <select
                id="appenv"
                value={appenv}
                onChange={(e) => setAppenv(e.target.value)}
              >
                <option value="local">Local</option>
                <option value="ci">Development</option>
                <option value="qa">QA</option>
                <option value="sbx">SBX</option>
                <option value="prod">Production</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="product">Product:</label>
              <select
                id="product"
                value={product}
                onChange={(e) => setProduct(e.target.value)}
              >
                <option value="MLT">MLT</option>
                <option value="VAT">VAT</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="entity">Entity ID:</label>
              <input
                type="text"
                id="entity"
                value={entity}
                onChange={(e) => setEntity(e.target.value)}
                placeholder="Enter Entity ID"
              />
            </div>
            <div className="form-group">
              <label htmlFor="token">Token:</label>
              <textarea
                id="token"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="Enter JWT Token"
                rows="4"
              />
            </div>
            <div className="popup-buttons">
              <button className="btn-cancel" onClick={handleCancel}>
                Cancel
              </button>
              <button className="btn-save" onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
